import React, { useState } from 'react'
import Select from 'react-select'
import { BANKS } from '../../../constants'

export interface IBankProps {
  name: string
  value?: string
  className?: string
  disable?: boolean
  onChange: (newValue: any) => void
}

const options = BANKS.map((bank: { BANKCD: any; BANKNAME: any; BANKSHORTNAME: any }) => ({
  value: bank.BANKCD,
  label: `${bank.BANKSHORTNAME} - ${bank.BANKNAME}`,
  shortName: bank.BANKSHORTNAME,
  bankName: bank.BANKNAME
}))

export const Bank: React.VFC<IBankProps> = ({ onChange, name, value, className, disable }) => {
  const handleOnChange = (newValue: any) => {
    //console.log('newValue', newValue)
    const result = { ...newValue, target: { name: name, value: newValue.bankName } }
    onChange(result)
  }

  return (
    <div className="App">
      <Select
        isDisabled={disable}
        className={className}
        onChange={handleOnChange}
        options={options}
        value={options.find((obj: any) => obj.value === value)}
      />
    </div>
  )
}
